import React from 'react';

import { useCreateOnboardingPlaylistAfterSignIn } from 'components/Processes/useCreateOnboardingPlaylistAfterSignIn';
import { useStoreOnboardingResponsesAfterSignIn } from 'components/Processes/useStoreOnboardingResponsesAfterSignIn';

const ProcessesWrapper = () => {
  useStoreOnboardingResponsesAfterSignIn();
  useCreateOnboardingPlaylistAfterSignIn();

  return <></>;
};

export default ProcessesWrapper;
